import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../auth.service';
import { MescModuleView, mescModules, mescAppUrl, } from './config';
import { utilities } from '../../../../src/modules/utility';

@Component({
  selector: 'mesc',
  templateUrl: './mesc.component.html',
  styleUrls: ['./mesc.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class MESCComponent implements OnInit {
  moduleViews: MescModuleView[];
  private isLocal = true;

  constructor(
    public router: Router,
    private readonly authService: AuthenticationService) { }

  ngOnInit() {
    this.moduleViews = mescModules;
    this.isLocal = window.location.hostname.includes('localhost');
  }

  /**
   * 
   */
  validatePath = (path: string): boolean => this.authService.isClaimValid(path);


  /**
   * 
   */
  getEndpoint = (module): string => {
    let url =
      mescAppUrl[utilities.getEnv()]
        .replace("mesc-ui", "mesc-ui-" + module.title.toLowerCase())
        .replace("#/MESC", "#/" + module.title.toUpperCase());

    if (utilities.getEnv() !== 'PROD') {
      url = url.replace("mesc.", `${module.title.toLowerCase()}.`)
    } else if (module.title === 'PHF') {
      url = 'https://phf.oc1i.gm.com/#/PHF'
    }
    if (module.title.toUpperCase() === 'CTWR') {
      url = url.replace('test', 'test2');
    }

    return this.isLocal ?
      module.route : url;
  }

}
